import * as actions from './actions';
import reducer from './reducer';
import { MetaState, metaSelectors } from './selectors';
import epics from './epics';

export { actions, reducer, MetaState, metaSelectors, epics };



// WEBPACK FOOTER //
// ./src/store/meta/index.ts